import client from '../api';
import axios from 'axios';
import qs from 'qs';

const CancelToken = axios.CancelToken;
let cancel;

export const getAvailableFacilitiesService = async (params) => {
  return await client.get(`api/scheduling/available-facilities/`, {
    params,
  });
};

export const getPeriodService = async (params) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.get('api/scheduling/', {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

// Same as getPeriodService, but does not cancel (or get cancelled by) the page's own period request.
export const getPeriodByDateService = async (params) => {
  return await client.get('api/scheduling/', { params });
};

export const getPeriodByIdService = async (periodID, params) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.get(`api/scheduling/${periodID}/`, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const addUnitRoleService = async (payload, params) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/roles/`, payload, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const updateUnitRoleService = async (roleId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.patch(`api/scheduling/roles/${roleId}/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const deleteUnitRoleService = async (roleId) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/roles/${roleId}/delete/`, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const getAvailableEmployeesService = async (periodID) => {
  return await client.get(`api/scheduling/${periodID}/available-employees/`);
};

export const bulkCreateSchedulingCellAssignmentsService = async (payload) => {
  return await client.post(`api/scheduling/assignments/bulk-create/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const bulkDeleteSchedulingCellAssignmentsService = async (payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/assignments/bulk-delete/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const bulkOffDueSchedulingCellAssignmentsService = async (payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/assignments/bulk-off-due-to/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const createSchedulingCellAssignmentService = async (payload) => {
  return await client.post(`api/scheduling/assignments/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const postShiftsService = async (schedulingPeriodId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/${schedulingPeriodId}/post-shifts/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const cancelPostedShiftsService = async (schedulingPeriodId) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(
    `api/scheduling/${schedulingPeriodId}/cancel-posted-shifts/`,
    {},
    {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    },
  );
};

export const postShiftCellService = async (cellId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/cells/${cellId}/post-shift/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const unpostShiftCellService = async (cellId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/cells/${cellId}/unpost-shift/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const deleteSchedulingCellAssignmentService = async (assignmentId) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.delete(`api/scheduling/assignments/${assignmentId}/`, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const updateSchedulingCellAssignmentService = async (assignmentId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.patch(`api/scheduling/assignments/${assignmentId}/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const offDueSchedulingCellAssignmentService = async (assignmentId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/assignments/${assignmentId}/off-due-to/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const getPickupShiftCellsService = async (params) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.get(`api/scheduling/cells/available-pickup-shifts/`, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const pickupShiftService = async (cellId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/cells/${cellId}/pickup-shift/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const getMyShiftsService = async (params) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.get(`api/scheduling/cells/my-shifts/`, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const processAssignmentRequestsService = async (payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/cells/process-requests/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const resetScheduleService = async (payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/reset-schedule/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const setCensusValueService = async (dayId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.post(`api/scheduling/days/${dayId}/set-census-value/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const updateDayNotesService = async (dayId, payload) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.post(`api/scheduling/days/${dayId}/update-notes/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const updateSchedulingNotificationsService = async (periodID, payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/${periodID}/update-scheduling-notifications/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const postScheduleService = async (periodID) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(
    `api/scheduling/${periodID}/post-schedule/`,
    {},
    {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    },
  );
};

export const getSchedulingPeriodLastModifiedService = async (periodID) => {
  return await client.get(`api/scheduling/${periodID}/last-modified/`);
};

export const getPeriodByIdSilentService = async (periodID) => {
  return await client.get(`api/scheduling/${periodID}/`);
};

export const getAssignmentRequests = async (periodID, params) => {
  return await client.get(`api/scheduling/${periodID}/assignment-requests/`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const getScheduleDataService = async (facilityId) => {
  return await client.get(`api/scheduling/master-schedule/`, {
    params: {
      facility_id: facilityId,
    },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });
};

export const getMasterScheduleAvailableUsersService = async (params) => {
  return await client.get(`api/scheduling/master-schedule/available-users/`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    },
  });
};

export const addUserToScheduleService = async (payload, params) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.post(`api/scheduling/master-schedule/add-user-to-schedule/`, payload, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const deleteUserFromScheduleService = async (payload, params) => {
  if (cancel !== undefined) {
    cancel();
  }

  return await client.post(`api/scheduling/master-schedule/delete-user-from-schedule/`, payload, {
    params,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const moveAssignmentToAnotherCellService = async (payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/assignments/move-to-another-cell/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};

export const moveMasterScheduleAssignmentToAnotherCellService = async (payload) => {
  if (cancel !== undefined) {
    cancel();
  }
  return await client.post(`api/scheduling/master-schedule/move-to-another-cell/`, payload, {
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
    }),
  });
};
